import styled from 'styled-components';

export const LayoutWrapper = styled('div')`
  width: 100%;
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  padding-top: ${({ theme }) => `calc(0px + ${theme.safeAreaInsetTop})`};
  background: ${({ theme }) => theme.color.noir};
`;

export const Portal = styled('div')``;
